import { MenuItem } from "./MenuItem";
import { useQuickActions } from "../../../../../app/hooks/useQuickActions";
import { useQuickCreate, QuickCreateEntityType } from "../../../../../app/context/QuickCreateContext";

const Separator = () => (
  <div className="d-flex align-items-center mx-1">
    <div
      style={{
        width: "1px",
        height: "24px",
        backgroundColor: "var(--bs-gray-300)",
      }}
    />
  </div>
);

export function MenuInner() {
  const { selectedActions } = useQuickActions();
  const { openCreateDialog } = useQuickCreate();

  return (
    <>
      {selectedActions.map((action) => {
        if (action.isSeparator) {
          return <Separator key={action.id} />;
        }

        // If action has createEntity, open dialog instead of navigating
        if (action.createEntity) {
          return (
            <MenuItem
              key={action.id}
              title={action.title}
              description={action.description}
              to={action.to}
              icon={action.icon}
              iconOnly={true}
              onClick={() => openCreateDialog(action.createEntity as QuickCreateEntityType)}
            />
          );
        }

        // Regular navigation action
        return (
          <MenuItem
            key={action.id}
            title={action.title}
            description={action.description}
            to={action.to}
            icon={action.icon}
            iconOnly={true}
          />
        );
      })}
    </>
  );
}
